import React, { useEffect, useState } from 'react';
import {
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
} from '@chakra-ui/react';
import { useForm, Controller } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import InputController from 'components/Form/InputController';
import { ModalType } from 'constants/common';
import { toast } from 'components/Toast';
import { useUpdateCategoryMutation, useCreateCategoryMutation } from 'services/category';
import { CategoryFormValidate } from 'utils/validation';
import { yupResolver } from '@hookform/resolvers/yup';

const CreateCategoryModal = ({ isOpen, categorysDetail, onClose, refetch }) => {
  const params = useParams();
  const cancelRef = React.useRef();
  const createCategoryMutation = useCreateCategoryMutation();
  const updateCategoryMutation = useUpdateCategoryMutation();
  const { control, handleSubmit, reset, setValue } = useForm({
    resolver: yupResolver(CategoryFormValidate),
    defaultValues: {
      name: '',
      url: '',
    },
  });

  useEffect(() => {
    if (categorysDetail) {
      reset({ name: categorysDetail.name, url: categorysDetail.url, id: categorysDetail.id });
    }
  }, [categorysDetail]);

  const handleSuccess = () => {
    toast.showMessageSuccess(`${categorysDetail ? 'Cập nhật' : 'Tạo'} shortlink thành công`);
    refetch?.();
    onClose(ModalType.Add);
  };
  const handleError = error => {
    toast.showMessageError(
      error?.response?.data?.errors?.[0]?.msg ||
        error?.response?.data?.msg ||
        `${categorysDetail ? 'Cập nhật' : 'Tạo'} shortlink thành công`
    );
  };
  const onSubmit = async values => {
    if (categorysDetail) {
      updateCategoryMutation.mutate(
        { name: values?.name, url: values?.url, id: values?.id, linkId: categorysDetail?._id },
        {
          onSuccess: () => {
            handleSuccess();
          },
          onError: error => handleError(error),
        }
      );
    } else {
      createCategoryMutation.mutate(
        { ...values },
        {
          onSuccess: () => handleSuccess(),
          onError: error => handleError(error),
        }
      );
    }
  };
  return (
    <>
      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        onClose={() => {
          onClose(ModalType.Add);
        }}
        isOpen={isOpen}
        isCentered
      >
        <AlertDialogOverlay />
        <AlertDialogContent maxW={'600px'} maxH={'400px'}>
          <AlertDialogHeader textTransform="uppercase">{categorysDetail ? 'Cập nhật' : 'Tạo'} Shortlink</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>
            <InputController control={control} name="name" label="Tên chiến dịch"/>
            <InputController control={control} name="url" label="Đường dẫn" type="textarea" />
            {categorysDetail && <InputController control={control} name="id" label="Mã short link" />}
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button
              ref={cancelRef}
              onClick={() => {
                onClose(ModalType.Add);
              }}
            >
              Hủy
            </Button>
            <Button
              colorScheme="blue"
              ml={3}
              isLoading={createCategoryMutation.isPending || updateCategoryMutation.isPending}
              onClick={handleSubmit(onSubmit)}
            >
              {categorysDetail ? 'Cập nhập' : 'Tạo'}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export default CreateCategoryModal;
